import { httpClient } from "@coworker/http-client";
import { Articles } from "../types/article";
import { Groups, GroupApiResponse, PartialGroup } from "../types/groups";
import { mapGroupApiResponseToGroup } from "../types/mappers";

export const addGroup = async (group: PartialGroup) => {
  return await httpClient.roomsettings.post<string>("/groups", {
    body: group,
    responseType: "text",
  });
};

export const getGroupsByMedia = async (mediaId: string) => {
  try {
    if (!mediaId) return [];
    const apiResponse = await httpClient.roomsettings.get<{
      groups: GroupApiResponse[];
    }>(`/groups/medias/${mediaId}`);
    const groups: Groups = apiResponse.groups.map(mapGroupApiResponseToGroup);
    return groups;
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};

export const getArticlesByGroupId = async (
  groupId: string
): Promise<Articles> => {
  try {
    const articles = await httpClient.roomsettings.get<Articles>(
      `/groups/articles/${groupId}`
    );
    return articles.sort((a1, a2) => (a1.itemName > a2.itemName ? 1 : -1));
  } catch (error) {
    console.error("Fetch error:", error);
  }
  return [];
};

export const updateGroup = async (groupId: string, group: PartialGroup) => {
  await httpClient.roomsettings.put(`/groups/${groupId}`, { body: group });
};

export const deleteGroupById = async (groupId: string) => {
  await httpClient.roomsettings.delete(`/groups/${groupId}`);
};
